<template>
  <div class="news-container">
    <!-- <page-top></page-top> -->
    <div class="content_wrap">
      <myImg
        img="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner_6.png"
      ></myImg>
      <my-tab
        :tab-list="tabList"
        @change="changeTab"
        :activeIndex="activeIndex"
        :bread-title="breadTitle"
        smallSize
      >
      </my-tab>
      <div class="news_list_box container" v-if="activeIndex == 1 && showList">
        <b-container v-if="newsList.length>0">
          <b-row>
            <b-col
              md="6"
              lg="4"
              v-for="(v, i) in newsList"
              :key="i"
              @click="checkDetail(i)"
            >
              <div class="news_list_box_item mt-40">
                <div class="img_mask">
                  <div>
                    <i class="el-icon-search"></i>
                  </div>
                  <img
                    :src="v.img"
                    class="item_img"
                    height="230px"
                    :alt="v.alt"
                  />
                </div>

                <div class="mt-20 color-fff fs-20">{{ v.title }}</div>
                <span>{{ v.date }}</span>
              </div>
            </b-col>
          </b-row>
        </b-container>
        <div class="container text-center color-ccc mt-30 fs-30 empty-tip" v-else>{{ $t('public.nomore') }}</div>
        <!-- <el-pagination
          background
          layout="prev, pager, next"
          :total="10"
          @@pagination="_getList"
        ></el-pagination> -->
      </div>
      <template v-if="activeIndex == 2">
        <div class="fs-24 mt-40 mb-40">{{ $t('public.nomore') }}</div>
        <!-- <h2 class="fs-24 mt-40 mb-40">
					第十九届广州国际汽车展览会疫情防控指引
				</h2>
				<div class="container fs-20">
					<div class="mb-30">尊敬的各参展商、各媒体以及其他与会工作人员：</div>
					<div class="text-in mb-20">
						为做好本届展会的疫情防控工作，根据广州市展览活动疫情防
						控工作相关指引，所有与会人员务必落实身份必录、绿码必查、体
						温必测、口罩必戴、消毒必做、突发必处的“六必原则”。现将本
						届展会的相关工作要求通知如下：
					</div>
					<div class="text-in mb-20">
						<span class="bold">一、严格执行实名制。</span>由布展、开展，到撤展全过程，所有与
						会人员都必须信息建档（见附件），按人员常住地区进行区分汇总。
					</div>
					<div class="text-in mb-20">
						<span class="bold">二、展前开展排查工作。</span>针对来自中、高风险区人员，10 月 25
						日起有发生疫情的城市旅居史的人员，遵循以下原则：
					</div>
					<div class="text-in mb-20">
						不接受来自中、高风险地区或 14 天内有中高风险区旅居史的
						人员入场【中、高风险区，及 10 月 25 日起有发生疫情但风险等级还
						没提高的城市，以县、县级市（副省级城市、省级市以区）为单位】。
					</div>
					<div class="text-in mb-20">
						该城市（地级市或副省级城市、省级市）其他地区人员进馆前， 须提供 48
						小时内的在穗核酸检测阴性证明，进入展馆后实行核酸
						“一天一检”，在穗期间实行相对闭环管理，限定活动场所为从展
						馆到居住酒店“两点一线”，并主动向主办单位报备其在穗行程。
					</div>
					<div class="text-in mb-20">
						（示例：北京市昌平区现有高风险地区 1 个、中风险地区 2 个，故昌平
						区人员原则上不接受入场；其他区人员进馆前，须提供 48 小时内在穗核酸 1
						检测阴性证明，进入展馆后实行核酸 “一天一检”
					</div>
					<div class="text-in mb-20">
						<span class="bold">三、实行自我健康监测。</span>所有与会人员于参会前
						14 天每日做 好自我健康监测；行程卡 14
						天内含有广东省以外旅居史的参会人 员，进馆时须持有 48
						小时内核酸检测阴性证明。
					</div>
					<div class="text-in mb-20">
						<span class="bold">四、持健康码入场。</span>所有与会人员必须持有粤康码、穗康码其
						中之一，健康码为绿码者可以进场，禁止持黄（红）码者入场。
					</div>
					<div class="text-in mb-20">
						<span class="bold">五、主动配合测温验码。</span>不允许出现任何单位或人员抵触或不
						配合测温验码，否则广州市展览督导组将协调取消该单位或人员进
						入本次展会的资格。
					</div>
					<div class="text-in mb-20">
						<span class="bold">六、规范佩戴口罩。</span>所有与会人员须佩戴好一次性使用医用口
						罩，并保持在馆内全程佩戴不得脱下。如口罩污损，须及时更换。
						广州市展览督导组将在展馆内不间断巡查期间，对不规范佩戴口罩
						人员将进行提醒，对拒不改正的人员将要求其离场。
					</div>
					<div class="text-in mb-20">
						<span class="bold">七、严格执行清洁消杀制度。</span>展前须对展位和展品进行全面清 洁洗消，每天至少 1
						次消毒，及时清运垃圾，确保无卫生死角，并 做好台账记录
					</div>
					<div class="text-in mb-20">
						<span class="bold">八、快速有效处置突发情况。</span>各展台须储备必要的药物和防疫
						物资，并安排专人负责处理现场发热、咳嗽及其他症状人员。对身
						体感到不适的工作人员应提前劝阻其进入展馆；当与会的人员的常
						住地（县区级行政区）出现疫情时，立即停止其所有参会活动并注
						销证件；出现突发情况时应立即报主办单位并将相关人员送至现场
						医疗点，同时配合做好人员转运、消毒、隔离等应急措施并全程跟踪
					</div>
					<div class="text-in mb-20">
						展馆现场医疗点信息：
					</div>
					<div class="text-in mb-20">
						A 区：珠江散步道 4 号馆 1 号柜台，电话：020-89130120；
					</div>
					<div class="text-in mb-20">
						B 区：珠江散步道 9 号馆 4 号柜台，电话：020-89124120；
					</div>
					<div class="text-in mb-20">
						<span class="bold">九、展会现场设置核酸检测点。</span>具体安排如下：
					</div>
					<div class="text-in mb-20">
						地点：A 区 Y 通道 2.1 号馆旁
					</div>
					<div class="text-in mb-20">
						开放时间：11 月 9 日-11 月 30 日，每天 9:30-17:30
					</div>
					<div class=" mb-40">（首次抵穗在机场、车站、码头等进行核酸检测者，可凭此 48 小
						时内的核酸阴性证明进馆，后期可在展会现场检测点进行检测。）
					</div>
					<a class="download"
						href="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/gzcz_fk.xlsx">附件：参会人员健康信息统计表</a>
					<div class="mt-60 text-right">广州汽车展组委会</div>
					<div class="mb-40 text-right">2021 年 11 月 6 日</div> 
				</div> -->
      </template>
      <div class="news_notice container" v-if="activeIndex == 0 && showList">
        <!-- <h2>暂无相关内容</h2> -->
        <b-container>
          <b-row>
            <b-col
              md="6"
              lg="4"
              v-for="(v, i) in noticeList"
              :key="i"
              @click="checkDetail(i)"
            >
              <div class="news_list_box_item mt-40" v-if="i < 9">
                <div class="img_mask">
                  <div>
                    <i class="el-icon-search"></i>
                  </div>
                  <img
                    :src="v.img"
                    class="item_img"
                    height="230px"
                    :alt="v.alt"
                  />
                </div>

                <div class="mt-20 color-fff fs-20">{{ v.title }}</div>
                <span>{{ v.date }}</span>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="detail_wrap container" v-if="detailFlag">
        <div
          v-html="
            activeIndex == 1
              ? newsList[curIndex].detail
              : noticeList[curIndex].detail
          "
        ></div>
      </div>
    </div>
    <!-- <page-bottom></page-bottom> -->
    <page-footer></page-footer>
  </div>
</template>

<script>
import pageTop from "@/components/pageTop";
// import pageBottom from "@/components/pageBottom";
import myTab from "@/components/myTab";
import myImg from "@/components/myImg";
import pageFooter from "@/components/pageFooter";
import merge from "webpack-merge";
export default {
  components: {
    pageTop,
    myImg,
    // pageBottom,
    myTab,
    pageFooter,
  },
  created(){
  },
  mounted() {
    this.changeTabs(this.tabs);
    // this.changeCurs(this.curs);
    console.log(this.newsContentList[0]);
    
  },
  data() {
    return {
      tabList: [
      {
          title: this.$t("newscenter.notice"),
          en: "Notice",
        },
        {
          title: this.$t("newscenter.news"),

          en: "News",
        }
      ],
      breadTitle: {
        cn: this.$t("newscenter.title"),
        en: "News Center",
      },
      tabs: this.$route.query.tab,
      curs: this.$route.query.cur,
      newsId: this.$route.query.newsId ? this.$route.query.newsId : "",
      noticeId: this.$route.query.noticeId ? this.$route.query.noticeId : "",
      activeIndex: 0,
      detailFlag: false,
      showList: true,
      curIndex: undefined,
      noticeList:[
      //   {
      //     id:9,
      //     title:'第二十一届广州国际汽车展览会媒体注册通知',
      //     img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner4.jpg",
      //     date:'2023-11-02',
      //     detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/20.png' alt/>`
      // }
    ],
    newsList:[
        {
          id:36,
          title:this._i18n.locale == "zh"?'新科技·新生活！第二十二届广州国际汽车展览会将于2024年11月15日至24日在广交会展馆盛大举办':'New Tech, New Life!The 22nd Guangzhou International Automobile Exhibition to be grandly held from November 15 to 24, 2024, at the Canton Fair Complex',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner4.jpg",
          date:'2024-09-13',
          // detail:this._i18n.locale == "en"? this.tempszh : this.tempseen,
          detail:this._i18n.locale == "zh"? `扬帆启航开新局，团结奋进谱新篇。广州国际汽车展览会（以下简称“广州国际车展”），自2003年创办以来，始终秉承“新科技·新生活”的主题理念，以为汽车行业打造高品质、国际化、综合性的展览体验平台为宗旨，与行业精英携手并进，砥砺前行，共同见证了中国汽车产业的发展与成长，参与了世界汽车工业的革新与重塑。<br>
<i class="text_indent_2"></i>第二十二届广州国际汽车展览会将于2024年11月15日至24日，在中国进出口商品交易会展馆盛大举办（以下简称“广交会展馆”）。本届展会规划使用广交会展馆A区、D区以及两区的室外展区，展会规模将创历史新高。<br>
<i class="text_indent_2"></i>本届车展吸引了国际汽车行业的目光，全球主流车企将以最高规格亮相广州国际车展。来自全球的整车企业将集中登录广州国际车展乘用车展区，为全球观众带来最新汽车科技产品；同期同馆的广州国际商用车展览会贴合新质生产力发展要求，展品全面覆盖智能化卡车、氢能及换电重卡、新能源物流车辆、轻量化厢式车、冷链运输车、皮卡改装专用车及各类房车；汽车产业链及汽车文化展区由原广州国际车展汽车零部件及用品展区升级而来，顺应汽车产业电动化、智能化发展新方向，规划了电机电控、充电储能、自动驾驶、智能座舱、生态互联、人工智能等新题材。广州国际车展三大展区形成完整的新时代汽车全产业链，着力发展汽车产业新质生产力，助力汽车行业形成高质量发展新格局。<br>
<i class="text_indent_2"></i>展会期间，还将同期举办多场汽车产业高峰论坛、沙龙及行业研讨会，来自政府部门、全球汽车行业、国际科技巨头及关联产业新锐、领军人物、专家学者等齐聚一堂，以各自独特的视角纵论全球行业发展大势、构建产业发展共同体、促进产业融合、加速汽车行业转型升级、为全球汽车行业可持续发展增添新动能。<br>
<i class="text_indent_2"></i>我们诚邀全球车企及汽车爱好者共襄盛举，共享前沿新科技，共创美好新生活。` : `The Guangzhou International Automobile Exhibition (AUTO GUANGZHOU) has adhered to the theme of “New Tech, New Life” since its inception in 2003.The event has always aimed to provide a high-quality exhibition platform for the international automotive industry. Over the years, it has closely collaborated with industry elites, advancing together with them while witnessing the development of China's automotive sector and participating in the transformation of global automotive industry.<br>
<i class="text_indent_2"></i>The AUTO GUANGZHOU 2024 will be grandly held from November 15 to 24, 2024, at the Canton Fair Complex. The AUTO GUANGZHOU 2024 will utilize Areas A and D of the Canton Fair Complex, including the outdoor spaces of the two areas, marking the largest show in the event’s history.<br>
<i class="text_indent_2"></i>The AUTO GUANGZHOU 2024 has captured the attention of the global automotive industry, with leading car manufacturers from around the world showcasing their innovations at the event. International vehicle manufacturers will gather in the Passenger Car Area, presenting the latest automotive technologies to a global audience. Simultaneously, the Guangzhou International Commercial Vehicle Exhibition, to be held in the same venue, will serve the development of new-quality productive forces. Exhibits will cover a wide range of products, including intelligent trucks, hydrogen-powered and battery-swappable heavy trucks, new energy logistics vehicles, lightweight vans, cold chain transport trucks, customized pickup trucks, and various RVs. The Automobile Industrial Chain & Automobile Culture Area, upgraded from the former Auto Parts and Accessories section, reflects the latest trends in electrification and intelligent automotive technologies. The exhibits will feature innovations in electric motors and controllers, charging and energy storage systems, autonomous driving, smart cockpits, connected ecosystems, artificial intelligence, and other new themes. Together, these three main exhibition areas form a complete ecosystem for the modern automotive industry, focusing on developing new-quality productive forces and driving the sector toward high-quality growth.<br>
<i class="text_indent_2"></i>During the event, multiple automotive industry summits, salons, and seminars will take place. Representatives from government, global automotive sector, international technology giants, emerging industry leaders, and academic experts will gather to share their unique insights. They will discuss the major trends shaping the global automotive industry, explore ways to build an industrial development community, promote cross-industry integration, accelerate the transformation and upgrading of the automotive sector, and contribute to the sustainable development of the global automotive industry.<br>
<i class="text_indent_2"></i>We cordially invite automotive enterprises and enthusiasts from around the world to join us in this grand event, share cutting-edge automotive technologies, and create a better future together.`

        },
        {
          id:34,
          title:'2024广州国际车展汽车产业链及汽车文化展区11月举办',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner4_c.jpg",
          date:'2023-05-31',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/34.jpg' alt/>`
        },
        {
          id:35,
          title:'2024第六届广州国际商用车展览会11月举办',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c35.webp",
          date:'2024-04-01',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/35.png' alt/>`
        },
        // {
        //   id:33,
        //   title:'2023广州车展圆满闭幕，第二十二届将于2024年11月15日至24日举办',
        //   img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c28.jpeg",
        //   date:'2023-11-26',
        //   detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/28.png' alt/>`
        // }
    ]
    };
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (to.query.tab != from.query.tab) {
        this.changeTabs(to.query.tab);
      }
    },
  },
  methods: {
    changeTabs(index) {
      let that = this;
      that.activeIndex = index;
      if (that.curs) {
        that.curIndex = that.curs;
        that.detailFlag = true;
        that.showList = false;
        that.$router.replace({
          query: merge(
            {},
            {
              tab: that.activeIndex,
              cur: that.curs,
            }
          ),
        });
      }
      // console.log(this.newsId);
      if (this.newsId) {
        this.newsList.map((item, index) => {
          if (this.newsId == item.id) {
            console.log(index);
            that.checkDetail(index);
            return;
          }
        });
      } else if (this.noticeId) {
        this.noticeList.map((item, index) => {
          if (this.noticeId == item.id) {
            // console.log(index);
            that.checkDetail(index);
            return;
          }
        });
      }
    },
    _getList(){

    },
    checkDetail(index) {
      this.curIndex = index;
      this.detailFlag = true;
      this.showList = false;
      this.$router.replace({
        query: merge(
          {},
          {
            tab: this.activeIndex,
            cur: this.curIndex,
          }
        ),
      });
    },
    changeTab(index) {
      this.activeIndex = index;
      this.detailFlag = false;
      this.showList = true;
      // console.log(this.activeIndex, this.showList);
    },
  },
};
</script>

<style lang="scss">
.news-container {
  width: 100vw;
  background: #221f26;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  cursor: default;
  min-height: 100vh;
  justify-content: space-between;

  .content_wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .son-page {
    width: 1920px;
    height: 300px;
    background-image: url("https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner_6.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .menu_wrap {
    width: 1200px;
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 60px;

    .news_wrap {
      height: 100px;
      border-bottom: 1px solid rgba($color: #fff, $alpha: 0.2);
      box-sizing: border-box;
      display: flex;

      > div {
        font-size: 30px;
        // width: 143px;
        line-height: 100px;
        text-align: center;
        color: #ccc;
        border-bottom: 2px solid transparent;
        margin-right: 50px;
      }

      .act-item {
        color: #42abff;
        border-bottom: 1px solid #42abff;
      }
    }

    .right_wrap {
      display: flex;
      color: rgba(255, 255, 255, 0.8);
      align-items: center;
    }
  }

  .news_list_box {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 50px;

    .news_list_wrap {
      width: 100%;
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;

      .news_item_card {
        display: flex;
        flex-direction: column;
        margin-bottom: 89px;
        width: 370px;

        // margin-right: 50px;
        .news_img {
          width: 370px;
          height: 260px;
          margin-bottom: 26px;
          position: relative;

          > img {
            width: 370px;
            height: 260px;
          }

          > div {
            visibility: hidden;
            position: absolute;
            width: 100%;
            height: 260px;
            background: rgba($color: #000000, $alpha: 0.5);
            display: flex;
            flex-direction: column;
            justify-content: center;

            > i {
              color: #fff;
              font-size: 50px;
              margin: 0 auto;
            }
          }
        }

        .news_img:hover {
          > div {
            visibility: visible;
          }
        }

        > h2 {
          width: 352px;
          // height: 22px;
          line-height: 40px;
          font-size: 22px;
          color: #ffffff;
          margin: 0;
        }

        .news_desc {
          width: 358px;
          max-height: 120px;
          font-size: 20px;
          color: #cccccc;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          line-height: 40px;
        }

        > span {
          // width: 81px;
          // height: 12px;
          line-height: 60px;
          font-size: 16px;
          color: #ffffff;
        }
      }
    }

    .news_list_box_item {
      .img_mask {
        position: relative;

        > div {
          visibility: hidden;
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba($color: #000000, $alpha: 0.5);
          display: flex;
          flex-direction: column;
          justify-content: center;

          > i {
            color: #fff;
            font-size: 50px;
            margin: 0 auto;
          }
        }
      }

      .img_mask:hover {
        > div {
          visibility: visible;
        }
      }
    }
  }

  .news_notice {
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 50px;

    .notice_list_wrap {
      // width: 1200px;
      width: 100%;
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;

      .notice_item_card {
        display: flex;
        flex-direction: column;
        margin-bottom: 89px;
        width: 470px;
        margin-right: 50px;

        .notice_img {
          width: 470px;
          height: 260px;
          margin-bottom: 26px;
          position: relative;

          > img {
            width: 470px;
            height: 260px;
          }

          > div {
            visibility: hidden;
            position: absolute;
            width: 470px;
            height: 260px;
            background: rgba($color: #000000, $alpha: 0.5);
            display: flex;
            flex-direction: column;
            justify-content: center;

            > i {
              color: #fff;
              font-size: 50px;
              margin: 0 auto;
            }
          }
        }

        .notice_img:hover {
          > div {
            visibility: visible;
          }
        }

        > h2 {
          width: 352px;
          // height: 22px;
          line-height: 40px;
          font-size: 22px;
          color: #ffffff;
          margin: 0;
        }

        .notice_desc {
          width: 358px;
          max-height: 120px;
          font-size: 20px;
          color: #cccccc;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          line-height: 40px;
        }

        > span {
          // width: 81px;
          // height: 12px;
          line-height: 50px;
          font-size: 16px;
          color: #ffffff;
        }
      }
    }

    .news_list_box_item {
      .img_mask {
        position: relative;

        > div {
          visibility: hidden;
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba($color: #000000, $alpha: 0.5);
          display: flex;
          flex-direction: column;
          justify-content: center;

          > i {
            color: #fff;
            font-size: 50px;
            margin: 0 auto;
          }
        }
      }

      .img_mask:hover {
        > div {
          visibility: visible;
        }
      }
    }
  }

  .detail_wrap {
    margin: 100px 0px;
    font-size:24px;
    line-height: 40px;
    text-indent: 48px;
    > div {
      display: flex;
      flex-direction: column;

      > h2 {
        text-align: center;
        color: #fff;
        font-size: 30px;
      }

      .detail_date {
        text-align: center;
        color: #ccc;
        margin-bottom: 56px;
        font-size: 20px;
        margin: 20px;
      }

      .detail_title {
        color: #42abff;
        font-size: 20px;
        margin-bottom: 53px;
      }

      .detail_desc {
        font-size: 20px;
        color: #ccc;
        text-indent: 50px;
        margin-bottom: 40px;
      }

      .text_right {
        text-align: right;
      }

      > img {
        margin: 50px 0px;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .news-container {
    .menu_wrap {
      width: 100vw;
      height: 200px;
      justify-content: center;

      .news_wrap {
        // width: 100%;
      }

      .right_wrap {
        display: none;
      }
    }

    .news_list_box {
      display: flex;
      flex-direction: column;
      align-items: center;

      .news_list_wrap {
        width: 100vw;
        padding: 0px 50px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .news_item_card {
          display: flex;
          flex-direction: column;
          margin-bottom: 89px;
          width: 46vw;

          .news_img {
            width: 100%;
            height: 520px;
            margin-bottom: 26px;
            position: relative;

            > img {
              width: 100%;
              height: 520px;
            }
          }

          > h2 {
            width: 100%;
            // height: 22px;
            font-size: 22px;
            color: #ffffff;
            line-height: 120px;
            // margin: 0;
          }

          .news_desc {
            width: 100%;
            max-height: 120px;
            font-size: 20px;
            color: #cccccc;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            line-height: 120px;
          }

          > span {
            font-size: 16px;
            color: #ffffff;
            line-height: 120px;
          }
        }
      }
    }

    .news_notice {
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;

      .notice_list_wrap {
        width: 100vw;
        padding: 0px 50px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .notice_item_card {
          display: flex;
          flex-direction: column;
          margin-bottom: 89px;
          width: 46vw;

          .notice_img {
            width: 100%;
            height: 520px;
            margin-bottom: 26px;
            position: relative;

            > img {
              width: 100%;
              height: 520px;
            }

            > div {
              visibility: hidden;
              position: absolute;
              width: 470px;
              height: 260px;
              background: rgba($color: #000000, $alpha: 0.5);
              display: flex;
              flex-direction: column;
              justify-content: center;

              > i {
                color: #fff;
                font-size: 50px;
                margin: 0 auto;
              }
            }
          }

          .notice_img:hover {
            > div {
              visibility: visible;
            }
          }

          > h2 {
            width: 100%;
            // height: 22px;
            line-height: 120px;
            font-size: 22px;
            color: #ffffff;
            margin: 0;
          }

          .notice_desc {
            width: 358px;
            max-height: 120px;
            font-size: 20px;
            color: #cccccc;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            line-height: 40px;
          }

          > span {
            // width: 81px;
            // height: 12px;
            line-height: 120px;
            font-size: 16px;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>

<style>
.news-container .el-breadcrumb__item .el-breadcrumb__inner {
  color: rgba(255, 255, 255, 0.8) !important;
}

.text-in {
  text-indent: 2em;
}

.bold {
  font-weight: bold;
}

.lh-60 {
  line-height: 100px !important;
}

.download {
  text-decoration: underline;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// index.vue?5684e3e6